import moment from "moment";
import { TAG } from "../../../../../../../../../component/generate-form/GenerateFormConfig";

export const formatDateToText = (value: string) => {
    if (!value) return '';

    const date = moment(value);

    const hour = date.get('hour');
    const minute = date.get('minute');
    const day = date.get('date').toString().padStart(2, '0');
    const month = (date.get('month') + 1).toString().padStart(2, '0');
    const year = date.get('year');

    return `${hour} giờ ${minute} phút, ngày ${day}/${month}/${year}`;
};

export const formatBirthdateToText = (day: number, month: number, year: number, delimiter = '') => {
    if (!day && !month && !year) return '';

	return [day, month, year]
		.filter((item) => item)
		.map((item) => item.toString().padStart(2, '0'))
		.join(delimiter);
};

export const isDisabledTab = (formJSONTag: string[]) => (formJSONTag ?? []).includes(TAG.DISABLED);